export default function getPagination(totalItems: number, itemsPerPage: number, page: number) {
  const totalPages = Math.floor((totalItems + itemsPerPage - 1) / itemsPerPage);
  const start = page * itemsPerPage - (itemsPerPage - 1);
  const end = Math.min(start + itemsPerPage - 1, totalItems);

  return {
    totalPages,
    start,
    end,
  };
}
